import moment from 'moment'
import 'moment/locale/pt-br'

const format = (date, format = 'L', origin = null) =>
  moment(date, origin).format(format)

const now = (format = 'L') => moment().format(format)

const parsePtBr = date => moment(date, 'DD/MM/YYYY')

const ofLegalAge = birthdate => {
  return parsePtBr(birthdate).isSameOrBefore(moment().subtract(18, 'years'))
}

const includesToday = (start, end, today = moment()) =>
  Boolean(start && end) &&
  today.isBetween(moment(start).startOf('day'), moment(end).endOf('day'), null, '[]')

const dates = { format, now, parsePtBr, ofLegalAge, includesToday }
export default dates
